export const ACTION_LOCATION = {
    BOOKING_MODIFICATION_SECTION: 'trip_details_booking_modification_section',
    NOTIFICATION_SECTION: 'trip_details_notification_section',
};

export const INTENTS = {
    ARRIVAL_BOT: 'VRBO_ARRIVAL_STARTER',
    REFUND_STATUS: 'REFUND_STATUS',
    VRBO_CANCEL: 'VRBO_CANCEL',
};

export const SKILL_TYPE = {
    ARRIVAL: 'arrival',
    REFUND_STATUS: 'refund_status',
    VRBO_CANCEL: 'cancel',
};

export const VAC_EVENTS = {
    VAC_CHAT_MESSAGE_SENT: 'VAC_ChatMsgSent',
    VAC_CONVERSATION_CREATED: 'VAC_ConversationCreated',
    VAC_CREATE_FRAME_FAILED: 'VAC_CreateFrameFailed',
    VAC_FRAME_ACTIVE: 'VAC_FrameActive',
    VAC_INITIALIZED: 'VAC_Initialized',
    VAC_START_FRAME_FAILED: 'VAC_StartFrameFailed',
    VAC_WIDGET_CLOSED: 'VAC_WidgetClosed',
    VAC_WIDGET_OPENED: 'VAC_WidgetOpened',
};

const {
    VAC_CHAT_MESSAGE_SENT,
    VAC_CONVERSATION_CREATED,
    VAC_CREATE_FRAME_FAILED,
    VAC_INITIALIZED,
    VAC_START_FRAME_FAILED,
    VAC_WIDGET_CLOSED,
    VAC_WIDGET_OPENED,
} = VAC_EVENTS;

export const EVENTS_TO_LISTEN = [
    /* Error cases */
    VAC_CREATE_FRAME_FAILED,
    VAC_START_FRAME_FAILED,
    /* Init */
    VAC_INITIALIZED,
    /* Post Init */
    VAC_CHAT_MESSAGE_SENT,
    VAC_CONVERSATION_CREATED,
    VAC_WIDGET_CLOSED,
    VAC_WIDGET_OPENED,
];
